var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-block"
  }, [_c('p', [_vm._v("l")]), _c('p', [_vm._v("i")]), _c('p', [_vm._v("n")]), _c('p', [_vm._v("k")]), _c('p', [_vm._v("n")]), _c('p', [_vm._v("a")]), _c('p', [_vm._v("u")])])]);

}]

export { render, staticRenderFns }